import { render, staticRenderFns } from "./Vetvine.vue?vue&type=template&id=4aae2706&scoped=true"
import script from "./Vetvine.vue?vue&type=script&lang=js"
export * from "./Vetvine.vue?vue&type=script&lang=js"
import style0 from "./Vetvine.vue?vue&type=style&index=0&id=4aae2706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae2706",
  null
  
)

export default component.exports